<template>
    <div class="f-manager">
        <veui-icon name="manage-order" class="f-manager-icon"/>
        <span class="f-manager-name" @click="deletePost">删除</span>

        <!-- 普通确认弹窗 -->
        <ui-confirm-box 
            :is-open="confirm"
            :title="confirmTitle"
            :tip="confirmTips"
            :btn-tip="confirmBtn"
            @operate="operate">
        </ui-confirm-box>
    </div>
</template>

<style lang="less">
    @import '../../../assets/less/components/manager-operation.less';
</style>

<script>
import {Icon} from 'veui';
import 'veui-theme-one-icons';
import ConfirmBox from '@/components/confirm-box/box';
import {throttle, debounce} from '@/utils/debounceThrottle.js';

export default {
    props: {
        topicid: {
            'type': Number,
            'default': 0
        }
    },
    components: {
        'veui-icon': Icon,
        'ui-confirm-box': ConfirmBox
    },
    data() {
        return {
            confirm: false,
            confirmTips: '',
            confirmBtn: '',
            confirmTitle: '',
            confirmType: ''
        };
    },
    methods: {
        deletePost() {
            this.confirm = true;
            this.confirmType = 'delete';
            this.confirmTitle = '确认删除帖子';
            this.confirmTips = '删除后帖子内容及回复将一并被删除，且不可恢复';
            this.confirmBtn = '删除';
        },
        ok: debounce(function () {
            this.managerOperation(this.confirmType);
        }),
        managerOperation: throttle(function (type) {
            let topicId = this.topicid;
            let enable = 1;
            this.$store.dispatch('managerOperation', {type, topicId, enable})
                .then(() => {
                    this.isShowMenu = false;
                    this.$emit('refreshlist', type);
                });
        }),
        changeConfirm(val) {
            this.confirm = val;
        },
        operate(type) {
            if (type === 'ok') {
                this.ok();
            }
            this.changeConfirm(false);
        }
    }
};
</script>
